import { render, staticRenderFns } from "./unlock-prescription-dialog.vue?vue&type=template&id=a9435d74&scoped=true&lang=pug&"
import script from "./unlock-prescription-dialog.vue?vue&type=script&lang=ts&"
export * from "./unlock-prescription-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./unlock-prescription-dialog.vue?vue&type=style&index=0&id=a9435d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9435d74",
  null
  
)

export default component.exports